<template>
  <modal :show="show" @change="$emit('change', $event)" width="700">
    <template v-slot:header>
      <span>{{ headerName }}</span>
    </template>
    <template v-slot:main>
      <div v-if="!applicationPost" class="modal-content">
        <div class="tes-text modal-content-text mt-4">
          {{$t('pages.paymentInformation.postDocument')}}:
          <br /><br />
          <div class="modalPayment__form-field">
            <v-text-field
              v-model="emails"
              :rules="emailRules"
              outlined
              required
              :disabled="loading"
            >
            </v-text-field>
          </div>

          <v-btn
            class="orange-button mb-5"
            :class="{'button-font': currentLocale === 'tat'}"
            :loading="loading"
            :disabled="!isValid"
            @click="sendApplication"
            >{{$t('buttons.post')}}
          </v-btn>
        </div>
      </div>
      <div v-if="success" class="modal-content">
        <div
          v-if="!applicationSuccess"
          class="tes-text modal-content-text mt-4"
        >{{approveMes}}
          <div>
            <v-btn class="orange-button mb-5 mt-5" @click="closeModal"
              >{{$t('buttons.close')}}
            </v-btn>
          </div>
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from "../common/Modal";
import {mapGetters} from 'vuex'

export default {
  name: "ModalInfo",
  components: { Modal },
  model: {
    prop: "show",
    event: "change",
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    email: {
      type: String,
      default: "",
    },
    domHoz: {
      type: String,
      default: "",
    },
    dateTo: {
      type: String,
      default: null,
    },
    dateFrom: {
      type: String,
      default: null,
    },
    isAgree: {
      type: String,
      default: null,
    },
    isAgreePeriod: {
      type: String,
      default: null,
    },
    provider: {
      type: Number,
      default: null,
    },
  },

  data: () => ({
    emails: null,
    applicationSuccess: false,
    success: false,
    applicationPost: false,
    loading: false,
    approveMes: null,
  }),

  computed: {
    headerName() {
      return this.success
        ? this.applicationSuccess
          ? this.$t('pages.paymentInformation.requestAccept')
          : ""
        : this.$t('pages.paymentInformation.verificationEmail');
    },
    isValid: function () {
      return (
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.emails)
      );
    },
    emailRules(){
      return [
      (v) => !!v || this.$t('rules.inputEmail'),
      (v) =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        this.$t('rules.incorrectEmail'),
      ]
    },
    ...mapGetters("locale",["currentLocale"]),
  },
  methods: {
    sendApplication() {
      this.loading = true;
      this.$store
        .dispatch("statements/SetApplicationForPaymentInfo", {
          dateTo: this.dateTo,
          dateFrom: this.dateFrom,
          isAgree: this.isAgree,
          isAgreePeriod: this.isAgreePeriod,
          provider: this.provider,
          domHoz: this.domHoz,
          emails: this.emails,
          userId: this.$store.state.account.userSettings.userGuid,
        })
        .then((result) => {
          this.loading = true;

          if (result.success) {
            if (result.checkApplicationDebt) {
              this.$emit('change', false);
            }
            this.applicationSuccess = result.checkApplicationDebt;
            this.applicationPost = true;
            this.success = result.success;
            this.approveMes = this.currentLocale === 'ru' ? result.approveMes : result.approveTatMes;
          }
          this.loading = false;
        });
    },
    closeModal() {
      this.$router.push("/");
    },
  },
  created() {
    this.emails = this.email;
  },

  watch: {},
};
</script>

<style lang="scss">
.modal-content-text {
  text-align: center;
  padding: 10px;
}

.modalPayment__form-field {
  position: relative;
  width: calc(100% - 32px);
  height: max-content;
  margin-left: 2.5%;
}
.modalPayment__form-item {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;
  width: 100%;
}
.button-font{
  font-family: Rubik-Medium !important;
  white-space: normal;
}
</style>